/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateWhatsAppResolveTemplateParametersPathParams,
	CandidateWhatsAppResolveTemplateParametersResponse,
} from '../types/CandidateWhatsAppResolveTemplateParameters'

/**
 * GET /candidates/:candidateId/whatsapp-templates/:templateId/parameters
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::resolveTemplateParameters
 */
export async function candidateWhatsAppResolveTemplateParameters(
	candidateId: CandidateWhatsAppResolveTemplateParametersPathParams['candidateId'],
	templateId: CandidateWhatsAppResolveTemplateParametersPathParams['templateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateWhatsAppResolveTemplateParametersResponse>> {
	return axiosInstance.get(`/candidates/${candidateId}/whatsapp-templates/${templateId}/parameters`, config)
}
